<template>
  <QIcon :color="currentColor" :size="size">
    <svg width="90" height="42" viewBox="0 0 90 42" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.7484 29.7541C15.7917 29.7541 14.202 31.3439 14.202 33.3005C14.202 35.2571 15.7917 36.8469 17.7484 36.8469C19.705 36.8469 21.2948 35.2571 21.2948 33.3005C21.2948 31.3439 19.705 29.7541 17.7484 29.7541ZM17.7484 34.1884C17.2592 34.1884 16.8605 33.7897 16.8605 33.3005C16.8605 32.8114 17.2592 32.4126 17.7484 32.4126C18.2375 32.4126 18.6363 32.8114 18.6363 33.3005C18.6363 33.7897 18.2375 34.1884 17.7484 34.1884Z"
        :fill="currentColor ? undefined : 'url(#icon0_linear)'"
      />
      <path
        d="M72.0075 29.7488C70.0509 29.7488 68.4558 31.3439 68.4558 33.3005C68.4558 35.2572 70.0509 36.8522 72.0075 36.8522C73.9641 36.8522 75.5592 35.2572 75.5592 33.3005C75.5592 31.3439 73.9641 29.7488 72.0075 29.7488ZM72.0075 34.1938C71.513 34.1938 71.1143 33.795 71.1143 33.3005C71.1143 32.8061 71.513 32.4073 72.0075 32.4073C72.502 32.4073 72.9008 32.8061 72.9008 33.3005C72.9008 33.795 72.502 34.1938 72.0075 34.1938Z"
        :fill="currentColor ? undefined : 'url(#icon1_linear)'"
      />
      <path
        d="M17.7484 24.7616C13.0376 24.7616 9.20938 28.5898 9.20938 33.3006C9.20938 38.0114 13.0429 41.8395 17.7484 41.8395C22.4538 41.8395 26.2873 38.0114 26.2873 33.3006C26.2873 28.5898 22.4538 24.7616 17.7484 24.7616ZM17.7484 39.1811C14.505 39.1811 11.8678 36.5439 11.8678 33.3006C11.8678 30.0572 14.505 27.4201 17.7484 27.4201C20.9917 27.4201 23.6289 30.0572 23.6289 33.3006C23.6289 36.5439 20.9917 39.1811 17.7484 39.1811Z"
        :fill="currentColor ? undefined : 'url(#icon2_linear)'"
      />
      <path
        d="M72.0076 24.7616C67.2968 24.7616 63.4686 28.5898 63.4686 33.3006C63.4686 38.0114 67.3021 41.8395 72.0076 41.8395C76.713 41.8395 80.5465 38.0114 80.5465 33.3006C80.5465 28.5898 76.7183 24.7616 72.0076 24.7616ZM72.0076 39.1811C68.7642 39.1811 66.127 36.5439 66.127 33.3006C66.127 30.0572 68.7642 27.4201 72.0076 27.4201C75.2509 27.4201 77.8881 30.0572 77.8881 33.3006C77.8881 36.5439 75.2509 39.1811 72.0076 39.1811Z"
        :fill="currentColor ? undefined : 'url(#icon3_linear)'"
      />
      <path
        d="M60.507 31.764H29.1477C28.414 31.764 27.8185 32.3595 27.8185 33.0932C27.8185 33.827 28.414 34.4225 29.1477 34.4225H60.507C61.2407 34.4225 61.8362 33.827 61.8362 33.0932C61.8362 32.3595 61.2407 31.764 60.507 31.764Z"
        :fill="currentColor ? undefined : 'url(#icon4_linear)'"
      />
      <path
        d="M86.8205 23.9055V17.0839C86.8205 16.5256 86.4696 16.0258 85.9485 15.8344C85.2573 15.5792 79.1375 13.3568 76.9523 13.0377C75.1445 12.7719 68.6047 12.6549 66.228 12.623C65.2285 10.3952 62.2085 4.15848 58.3005 0.51639C58.0559 0.287762 57.7316 0.160156 57.3966 0.160156H42.1902C40.6856 0.160156 39.4573 1.38836 39.4573 2.89305V14.9306H2.25485C1.56897 14.9306 0.994744 15.4516 0.930941 16.1322L0.00579635 25.8621C-0.00483749 25.9685 0.000479426 26.0748 0.0111133 26.1812L0.936257 32.5668C1.03196 33.2208 1.59024 33.7046 2.24954 33.7046H6.32762C7.06135 33.7046 7.65685 33.1091 7.65685 32.3754C7.65685 31.6416 7.06135 31.0461 6.32762 31.0461H3.39799L2.65894 25.9578L3.45648 17.5997H40.7759C41.5097 17.5997 42.1052 17.0042 42.1052 16.2704V2.89837C42.1052 2.85583 42.1371 2.82393 42.1796 2.82393H56.849C60.959 6.91796 64.08 14.3776 64.1119 14.4574C64.314 14.9465 64.7925 15.2708 65.3242 15.2762C67.8869 15.3027 74.8946 15.4303 76.5535 15.6749C77.9572 15.8823 81.9395 17.2381 84.1461 18.025V24.7669C84.1461 25.6973 84.9064 26.4576 85.8369 26.4576C86.6663 26.4576 87.3415 27.1329 87.3415 27.9623V30.6314C87.3415 31.2588 86.8311 31.7746 86.1984 31.7746H83.5187C82.7849 31.7746 82.1894 32.3701 82.1894 33.1038C82.1894 33.8375 82.7849 34.433 83.5187 34.433H86.1984C88.2933 34.433 90 32.7263 90 30.6314V27.9623C90 26.0004 88.6335 24.3521 86.8045 23.9162L86.8205 23.9055Z"
        :fill="currentColor ? undefined : 'url(#icon5_linear)'"
      />
      <path
        d="M60.5602 15.8876H47.5709V6.56706C47.5709 5.83332 46.9754 5.23782 46.2417 5.23782C45.508 5.23782 44.9125 5.83332 44.9125 6.56706V17.2168C44.9125 17.9506 45.508 18.5461 46.2417 18.5461H60.5602C61.2939 18.5461 61.8894 17.9506 61.8894 17.2168C61.8894 16.4831 61.2939 15.8876 60.5602 15.8876Z"
        :fill="currentColor ? undefined : 'url(#icon6_linear)'"
      />
      <path
        d="M51.548 23.9268C52.2817 23.9268 52.8772 23.3313 52.8772 22.5975C52.8772 21.8638 52.2817 21.2683 51.548 21.2683H46.8851C46.1513 21.2683 45.5558 21.8638 45.5558 22.5975C45.5558 23.3313 46.1513 23.9268 46.8851 23.9268H51.548Z"
        :fill="currentColor ? undefined : 'url(#icon7_linear)'"
      />
      <defs>
        <linearGradient id="icon0_linear" x1="45" y1="0.160156" x2="45" y2="41.8395" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon1_linear" x1="45" y1="0.160156" x2="45" y2="41.8395" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon2_linear" x1="45" y1="0.160156" x2="45" y2="41.8395" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon3_linear" x1="45" y1="0.160156" x2="45" y2="41.8395" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon4_linear" x1="45" y1="0.160156" x2="45" y2="41.8395" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon5_linear" x1="45" y1="0.160156" x2="45" y2="41.8395" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon6_linear" x1="45" y1="0.160156" x2="45" y2="41.8395" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
        <linearGradient id="icon7_linear" x1="45" y1="0.160156" x2="45" y2="41.8395" gradientUnits="userSpaceOnUse">
          <stop style="stop-color: var(--icon-gradient-color1, #00aeaa)" />
          <stop offset="1" style="stop-color: var(--icon-gradient-color2, #002856)" />
        </linearGradient>
      </defs>
    </svg>
  </QIcon>
</template>
<script>
import { QIcon } from 'quasar';
export default {
  name: 'TruckIcon',
  props: {
    color: {
      type: String
    },
    size: {
      type: String
    }
  },
  data() {
    return {
      currentColor: this.color
    };
  },
  watch: {
    color(value) {
      this.currentColor = value;
    }
  },
  components: { QIcon }
};
</script>
